import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { EVENT_NAMES } from "@scrile/api-provider/dist";
import MainRouterView from "router/MainRouterView";
import RouteController from "router/RouteController";
import { AppStateContextProvider } from "hooks/useAppState";
import useAuthUser, { AuthUserContextProvider } from "hooks/useAuthUser";
import { AuthUserVerificationContextProvider } from "hooks/useAuthUserVerificationStatus";
import useCustomDomain, { CustomDomainContextProvider } from "hooks/useCustomDomain";
import { PerformersContextProvider } from "hooks/usePerformers";
import { getLoginData } from "lib/authHelper";
import emitter from "lib/emitter";
import ModalBalanceRefill from "modals/ModalBalanceRefill";
import AppointmentBanner from "components/AppointmentBanner";
import CalendlyEventListener from "components/CalendlyEventListener";
import PageFooter from "components/PageFooter";
import PageHeader from "components/PageHeader";
import PushManager from "components/PushManager";
import "./styles/App.scss";

function App() {
  const { setLoginData } = useAuthUser();
  const { loadData, isLoading } = useCustomDomain();

  useEffect(() => {
    const onEvent = (data: any) => {
      const oldData = getLoginData();
      if (JSON.stringify(data) === JSON.stringify(oldData)) return;
      setLoginData(data);
    };
    emitter.on(EVENT_NAMES.SET_USER, onEvent);
    return () => emitter.off(EVENT_NAMES.SET_USER, onEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (isLoading) return null;

  return (
    <>
      <PageHeader />
      <AppointmentBanner />
      <main className="main">
        <div className="container">
          <MainRouterView />
        </div>
      </main>
      <PageFooter />
      <RouteController />
      <PushManager />
    </>
  );
}

export function WrappedApp() {
  return (
    <AuthUserContextProvider>
      <AuthUserVerificationContextProvider>
        <AppStateContextProvider>
          <CustomDomainContextProvider>
            <PerformersContextProvider>
              <App />
              <ModalBalanceRefill />
              <CalendlyEventListener />
            </PerformersContextProvider>
          </CustomDomainContextProvider>
        </AppStateContextProvider>
      </AuthUserVerificationContextProvider>
    </AuthUserContextProvider>
  );
}

export default function BrowserApp() {
  return (
    <Router>
      <WrappedApp />
    </Router>
  );
}
